export const DEFAULT_SIGNAL_URL = "wss://signal.jiahengli.xyz";
